export default {
    namespaced: true,
    state:{
        modal: null,
        player: null
    },
    mutations:{
        SET_MODAL(state, ref){
            state.modal = ref
        },
        SET_PLAYER(state, ref){
            state.player = ref
        }
    },
    actions:{
        initModal(context, payload){
            context.commit("SET_MODAL", payload)
        },
        initPlayer(context, payload){
            context.commit("SET_PLAYER", payload)
        }
    }
}